import { OTHER_VALUE } from '@ui-common/constants'
import { getEditLabel } from '@ui-common/utils'
import { StepSummary, StepSummaryView } from '@ui-components/form/StepSummaryView'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { isFormDataValid } from '../../../wizard/wizardData'
import { WizardStep } from '../../wizard/wizardMachine'
import { createFormValidator } from './formValidator'
import { IfpHouseholdInfoFormData } from './types'

export const HouseholdInfoSummary = ({
  data,
  onEditRequest,
}: {
  data: IfpHouseholdInfoFormData | undefined
  onEditRequest?: (stepType: WizardStep) => void
}) => {
  const intl = useIntl()

  const error = useIsHouseholdInfoComplete(data)
    ? undefined
    : intl.formatMessage(
        { id: 'common-dependant-info-changed' },
        {
          parentSection: intl.formatMessage({ id: 'ifp-loans-info-step-heading' }),
          section: intl.formatMessage({ id: 'ifp-loans-household-info-step-heading' }),
        },
      )

  const summary: StepSummary = {
    heading: intl.formatMessage({ id: 'ifp-loans-household-info-step-heading' }),
    error,
    data: [
      {
        heading: intl.formatMessage({ id: 'ifp-loans-household-info-adults-label' }),
        value: data?.numberOfAdults,
      },
      {
        heading: intl.formatMessage({ id: 'ifp-loans-household-info-children-label' }),
        value: data?.numberOfChildren === OTHER_VALUE ? data.numberOfChildrenOther : data?.numberOfChildren,
      },
    ],
    editItemProperties: onEditRequest && {
      onClick: () => onEditRequest(WizardStep.HouseholdInfoStep),
      label: getEditLabel(intl),
    },
  }

  return <StepSummaryView {...summary} />
}

const useIsHouseholdInfoComplete = (data: IfpHouseholdInfoFormData | undefined) => {
  return useMemo(() => isFormDataValid(data, createFormValidator), [data])
}
